import * as React from "react";

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: "default" | "secondary";
}

/**
 * Unstyled badge primitive: lets caller supply bg/text/border classes.
 */
export function Badge({ className = "", ...rest }: BadgeProps) {
  const base =
    "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium border";
  // Neutral border only; no bg/text defaults that could override caller.
  return <span className={`${base} border-zinc-300 dark:border-zinc-700 ${className}`} {...rest} />;
}
